import { render, staticRenderFns } from "./ExamsOverall.vue?vue&type=template&id=52aab702"
import script from "./ExamsOverall.vue?vue&type=script&lang=js"
export * from "./ExamsOverall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports